import AdwordsImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/adwardsLogoWhiteBg.png";
import MetaImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/metaLogoWhiteBg.png";
import DV360Image from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/dv360LogoWhiteBg.png";
import IonImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/ionLogoWhiteBg.png";
import ViImage from "../../../../../assets/images/platformWhiteBgIcons/1x-Icons/vodafone.png";

export const enumDataPlatForm = {
  ads: {
    key: "ads",
    availableMedia: [
      { key: 2, value: "search", text: "Search" },
      { key: 0, value: "display", text: "Display" },
    ],
    logo: AdwordsImage,
    isVisible: true,
  },
  meta: {
    key: "meta",
    availableMedia: [
      { key: 0, value: "display", text: "Display" },
      { key: 1, value: "video", text: "Video" },
    ],
    logo: MetaImage,
    isVisible: true,
  },
  dv360: {
    key: "dv360",
    availableMedia: [
      { key: 0, value: "display", text: "Display" },
      { key: 1, value: "video", text: "Video" },
    ],
    logo: DV360Image,
    isVisible: true,
  },
  //   tiktok: {
  //     key: "tiktok",
  //     availableMedia: [{ key: 2, value: "video" }],
  //   },
  ion: {
    key: "ion",
    availableMedia: [
      { key: 0, value: "display", text: "Display" },
      { key: 1, value: "video", text: "Video" },
    ],
    logo: IonImage,
    isVisible: false,
  },
  viads: {
    key: "viads",
    availableMedia: [
      { key: 0, value: "display", text: "Display" },
      { key: 1, value: "video", text: "Video" },
    ],
    logo: ViImage,
    isVisible: true,
  },
  ioh: {
    key: "ioh",
    availableMedia: [
      { key: 0, value: "display", text: "Display" },
      { key: 1, value: "video", text: "Video" },
    ],
    logo: IonImage,
    isVisible: false,
  },
};

export const enumMediaTypeKey = {
  search: "search",
  display: "display",
  video: "video",
  displayVideo: "displayVideo",
};

export const mediaConfigKeyData = {
  3: "displayVideo",
  2: "search",
  0: "display",
  1: "video",
};

export const platformConfig = {
  ads: "Google Ads",
  google: "Google Ads",
  beki: "beki",
  ion: "ION",
  meta: "Meta",
  dv360: "DV360",
  tiktok: "TikTok",
  viads: "ViAds",
  ioh: "IOH",
};

export const statusType = {
  0: {
    status: "Inactive",
    badgeCss: "badge bg-label-danger",
  },
  1: {
    status: "Active",
    badgeCss: "badge bg-label-success",
  },
  2: {
    status: "Draft",
    badgeCss: "badge bg-label-warning",
  },
  3: {
    status: "Draft",
    badgeCss: "badge bg-label-warning",
  },
  4: {
    status: "Budget Exceeded",
    badgeCss: "badge bg-label-danger",
  },
  5: {
    status: "Yet to be live",
    badgeCss: "badge bg-label-info",
  },
  6: {
    status: "Expired",
    badgeCss: "badge bg-label-danger",
  },
};

export const modalKeys = {
  addCampaignModal: "addCampaignModal",
  addStrategyCreativeModal: "addStrategyCreativeModal",
  openViewCreativeModal: "openViewCreativeModal",
  openUtmModal: "openUtmModal",
  openAddCreativeModal: "openAddCreativeModal",
};

export const campaignMessages = {
  error500: "Something went wrong",
  daypartAllFeildRequired: "Please complete all entries for the day part.",
  strategyCloneSuccess: "Strategy cloned successfully",
  campaignCloneSuccess: "Campaign cloned successfully",
  pageSelectMetaError: "Please select page for meta",
  locationSelectMetaError: "Please select location for meta",
  pleaseAddStrategyMessage: "Please add strategy",
  pleaseAddHeadingMessage: "Please add heading / description",
  pleaseAddCreativesMessage: "Please add creatives in strategy",
  pleaseFillRequiredFeilds: "Please fill all the required fields",
  ioFieldError: "Please complete all entries for the IO",
};

export const campaignStaticData = {
  responseCode: {
    msg: "Campaign List Fetched Successfully",
    status: "Success",
    code: 20010,
  },
  response: [
    {
      mandateId: 480,
      id: 744,
      name: "Test Status Camp May 15 02_ads_1",
      budget: 2,
      pacingType: 29,
      durationType: 23,
      platformName: "ads",
      platformId: 4,
      mediaType: 2,
      startDate: "2024-05-17",
      endDate: "2024-05-23",
      status: 5,
      accountId: "4774633019",
      targeting: {
        location: [],
        audience: [],
        language: [],
        daypart: [],
        device: [],
        adRotation: 1,
      },
      strategies: [
        {
          name: "Test Status Camp May 15 02_ads_1_ads_Strategy_1",
          id: 748,
          campaignId: 744,
          startDate: "2024-05-17",
          endDate: "2024-05-23",
          mediaType: 2,
          status: 2,
          pacingTypeName: "Standard",
          durationTypeName: "Daily",
          biddingStrategy: "1795",
          biddingStrategyName: "Maximize click",
          platformId: 4,
          isLocationPresent: false,
          isAudiencePresent: false,
          isKeywordPresent: false,
          isDayPartPresent: false,
          isPositionPresent: false,
          isSitesPresent: false,
          targeting: {
            location: [],
            audience: [],
            language: [],
            daypart: [],
            device: [],
            age: [],
            position: [],
            keyword: [],
            sites: [],
            gender: [],
          },
          creative: {
            utm: "",
            campaignId: 744,
            strategyId: 748,
            creatives: [
              {
                status: 1,
                creativeId: 624,
                campaignId: 744,
                strategyId: 748,
                heading: ["Heading 1", "Heading 2", "Heading 3"],
                description: ["Description 1", "Description 2", "Desc"],
                landingUrl: "https://beki.torcai.com",
                errorMessage: "",
                platCreativeId: "699629217083",
              },
            ],
          },
          errorMessage: "",
          platformStrategyId: "163109183955",
          syncedAttributes: {},
          synced: 0,
        },
      ],
      pacingTypeName: "Standard",
      durationTypeName: "Daily",
      biddingStrategy: "1795",
      biddingStrategyName: "Maximize click",
      checked: false,
      errorMessage: "",
      accountName: "testing google ads",
      platformCampId: "21293597741",
      pacingBudget: 0.29,
      syncedAttributes: {},
      totalBudget: 2,
      synced: 0,
      isReco: 0,
    },
    {
      mandateId: 480,
      id: 745,
      name: "Test Status Camp May 15 02_dv360_1",
      budget: 2,
      pacingType: 27,
      durationType: 140,
      platformName: "dv360",
      platformId: 5,
      startDate: "2024-05-15",
      endDate: "2024-05-23",
      status: 0,
      accountId: "1379087005",
      strategies: [
        {
          name: "Test Status Camp May 15 02_dv360_1_dv360_Strategy_1",
          id: 749,
          campaignId: 745,
          budget: 1,
          startDate: "2024-05-15",
          endDate: "2024-05-23",
          mediaType: 3,
          status: 0,
          pacingBudget: 0.11,
          pacingType: 27,
          durationType: 140,
          pacingTypeName: "Even",
          durationTypeName: "Lifetime",
          biddingStrategy: "1801",
          biddingStrategyName: "Maximize Clicks",
          bidCap: 0.1,
          platformId: 5,
          isLocationPresent: false,
          isAudiencePresent: false,
          isKeywordPresent: false,
          isDayPartPresent: false,
          isPositionPresent: false,
          isSitesPresent: false,
          targeting: {
            location: [],
            audience: [],
            language: [],
            daypart: [],
            device: [],
            age: [],
            position: [],
            keyword: [],
            sites: [],
            gender: [],
          },
          creative: {
            utm: "",
            campaignId: 745,
            strategyId: 749,
            creatives: [
              {
                status: 1,
                id: 702,
                creativeId: 625,
                campaignId: 745,
                strategyId: 749,
                errorMessage: "Failed to upload asset",
              },
            ],
            creativeDetails: [
              {
                id: 603,
                platId: 5,
                title: "Test Creative",
                isApproved: 0,
                crType: 21,
                description: "",
                heading: "Heading 1",
                landingUrl: "https://beki.torcai.com",
                tags: [],
                isRecActive: 1,
                isActive: 1,
                mediaList: [
                  {
                    id: 702,
                    gcId: 603,
                    adSize: "300X250",
                    isRecActive: 1,
                    isActive: 1,
                    url: "https://stagecdn.torcai.com/image/1732/1715778148449_ibus_300x250.png",
                    mimeType: "image/png",
                    bitrate: 0,
                    duration: 0,
                    tagUrl: "",
                    isApproved: 0,
                    trackers: [],
                  },
                ],
                isSynced: 0,
              },
            ],
          },
          errorMessage: "",
          platformStrategyId: "21293841008",
          syncedAttributes: {},
          synced: 0,
        },
        {
          name: "Test Status Camp May 15 02_dv360_1_dv360_Strategy_2",
          id: 763,
          campaignId: 745,
          budget: 2,
          startDate: "2024-05-15",
          endDate: "2024-05-23",
          mediaType: 0,
          status: 1,
          pacingBudget: 0.22,
          pacingType: 27,
          durationType: 138,
          pacingTypeName: "Even",
          durationTypeName: "Daily",
          biddingStrategy: "2973",
          biddingStrategyName: "Manual CPC",
          platformId: 5,
          isLocationPresent: false,
          isAudiencePresent: false,
          isKeywordPresent: false,
          isDayPartPresent: false,
          isPositionPresent: false,
          isSitesPresent: false,
          targeting: {
            location: [],
            audience: [],
            language: [],
            daypart: [],
            device: [],
            age: [],
            position: [],
            keyword: [],
            sites: [],
            gender: [],
          },
          creative: {
            utm: "",
            campaignId: 745,
            strategyId: 763,
            creatives: [
              {
                status: 1,
                id: 701,
                creativeId: 628,
                campaignId: 745,
                strategyId: 763,
              },
            ],
            creativeDetails: [
              {
                id: 602,
                platId: 5,
                title: "Test Creative May14",
                isApproved: 0,
                crType: 21,
                description: "Test Creative Description May14",
                heading: "Test Creative Heading May14",
                landingUrl: "https://beki.torcai.com",
                tags: [],
                isRecActive: 1,
                isActive: 1,
                mediaList: [
                  {
                    id: 701,
                    gcId: 602,
                    adSize: "300X250",
                    isRecActive: 1,
                    isActive: 1,
                    url: "https://stagecdn.torcai.com/image/1732/1715682744728_3_300x250.jpg",
                    mimeType: "image/jpeg",
                    bitrate: 0,
                    duration: 0,
                    tagUrl: "",
                    isApproved: 0,
                    trackers: [],
                  },
                ],
                isSynced: 0,
              },
            ],
          },
          syncedAttributes: {
            bidCap: {
              viewOnly: true,
              newValue: "0.0",
              isLiLevel: false,
            },
          },
          synced: 0,
        },
      ],
      pacingTypeName: "Even",
      durationTypeName: "Lifetime",
      checked: false,
      errorMessage: "",
      accountName: "Infomo Dubai",
      platformCampId: "54470102",
      pacingBudget: 0.22,
      syncedAttributes: {},
      totalBudget: 2,
      synced: 0,
      isReco: 0,
    },
    {
      mandateId: 480,
      id: 768,
      name: "Test Status Camp May 15 02_meta_1",
      budget: 0,
      platformName: "meta",
      platformId: 3,
      startDate: "2024-05-15",
      endDate: "2024-05-23",
      status: 2,
      strategies: [],
      checked: false,
      pacingBudget: 0,
      syncedAttributes: {},
      totalBudget: 0,
      synced: 0,
      isReco: 0,
    },
  ],
  length: 0,
  responseObj: {
    totalBudget: 10,
    campaignId: 480,
    campaignName: "Test Status Camp May 15 02",
    goal: 355,
    goalValue: 0.1,
    startDate: "2024-05-15",
    endDate: "2024-05-23",
    businessType: 351,
    brandName: "Beki",
    brandUrl: "https://beki.torcai.com",
    category: 160,
    subcategory: 183,
    advId: 1732,
    id: 480,
    isRecActive: 0,
    planList: [],
    isReco: 0,
  },
};
